import AdminMainTable from "../../components/Admin/AdminMainTable";

function AdminMain() {
  return <AdminMainTable></AdminMainTable>;
}

export default AdminMain;
